import { render, staticRenderFns } from "./AiInvoices.vue?vue&type=template&id=5e51216b&"
import script from "./AiInvoices.vue?vue&type=script&lang=js&"
export * from "./AiInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports